import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import TableData from "../data/table/commitee.json";
import Commitee from "../components/table/Commitee";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

// const divStyle1={
//     mso-tab-count:1

// };

// const divStyle2={
//     mso-list:"Ignore"

// };

const Committees = () => {
  return (
    <React.Fragment>
      <SEO title="Committees | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Committees"
        content="The Conference"
        contentTwo="Committees"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <div className="committee">
            <p>
              <b>
                <h5>Honorary Chair</h5>
              </b>
            </p>

            <p> Russ Eberhart &nbsp; | &nbsp; Indiana University Purdue University Indianapolis (IUPUI) &nbsp; | &nbsp; Indiana, USA </p>



            <p><span>&nbsp;</span></p>


            <p>
              <b>
                <h5>Advisory Committee Co-chairs</h5>
              </b>
            </p>

            <p> Gary G. Yen &nbsp; | &nbsp; Okahoma University &nbsp; | &nbsp; Oklahoma, USA </p>
            <p> Xin Yao &nbsp; | &nbsp; Southern University of Science and Technology of China &nbsp; | &nbsp; Shenzhen, China </p>
            <p> Yaochu Jin &nbsp; | &nbsp; Bielefeld University &nbsp; | &nbsp; Bielefeld, Germany </p>

            <p><span>&nbsp;</span></p>


            <p>
              <b>
                <h5>General Chair</h5>
              </b>
            </p>

            <p> Ying Tan &nbsp; | &nbsp; Peking University &nbsp; | &nbsp; Beijing, China </p>


            <p><span>&nbsp;</span></p>





            <p></p>



            <p>
              <b>
                <h5>Program Committee Chair</h5>
              </b>
            </p>

            <p>
              <span>
                Yuhui Shi | Southern University of Science and Technology | China
              </span>
            </p>
            

            <p>
              <span>&nbsp;</span>
            </p>


            <p>
              <span>&nbsp;</span>

              <b>
                <h5>Technical Committee Co-chairs</h5>
              </b>
            </p>


            <p> Kay Chen Tan &nbsp; | &nbsp; Hong Kong Polytechnic University &nbsp; | &nbsp; Hong Kong, China </p>
            <p> Qingfu Zhang &nbsp; | &nbsp; City University of Hong Kong &nbsp; | &nbsp; Hong Kong, China </p>
            <p> Haibo He &nbsp; | &nbsp; University of Rhode Island Kingston &nbsp; | &nbsp; Rhode Island, USA </p>
            <p> Martin Middendorf &nbsp; | &nbsp; University of Leipzig &nbsp; | &nbsp; Leipzig, Germany </p>
            <p> Xiaodong Li &nbsp; | &nbsp; RMIT University &nbsp; | &nbsp; Melboune, Australia </p>
            <p> Hideyuki TAKAGI &nbsp; | &nbsp; Kyushu University &nbsp; | &nbsp; Fukuoka, Japan </p>
            <p> Ponnuthurai Nagaratnam Suganthan &nbsp; | &nbsp; Nanyang Technological University &nbsp; | &nbsp; , Singapore </p>
            <p> Mengjie Zhang &nbsp; | &nbsp; Victoria University of Wellington &nbsp; | &nbsp; Wellington, New Zealand </p>
            <p> Nikola Kasabov &nbsp; | &nbsp; Auckland University of Technology &nbsp; | &nbsp; Auckland, New Zealand </p>
            <p> Jinliang Ding &nbsp; | &nbsp; Northeast University &nbsp; | &nbsp; Shenyang, China </p>
            <p> Shengxiang Yang &nbsp; | &nbsp; De Montfort University &nbsp; | &nbsp; Leicester, UK </p>
            <p> Yew-Soon Ong &nbsp; | &nbsp; Nanyang Technological University  &nbsp; | &nbsp; Singapore, Singapore </p>
            <p> Andries Engelbrecht &nbsp; | &nbsp; University of Pretoria &nbsp; | &nbsp; Pretoria, South Africa </p>
            <p> Yun Li &nbsp; | &nbsp; Shenzhen Higher Academy, Electronic Technolgy University &nbsp; | &nbsp; Shenzhen, China </p>
            <p> Honggui Han &nbsp; | &nbsp; Beijing University of Technology &nbsp; | &nbsp; Beijing, China </p>
            <p> Ling Wang &nbsp; | &nbsp; Tsinghua University &nbsp; | &nbsp; Beijing, China </p>
            <p> Haibin Duan &nbsp; | &nbsp; Beihang University &nbsp; | &nbsp; Beijing, China </p>


            <p><span>&nbsp;</span></p>




            <p>
              <b>
                <h5>Plenary Session Co-chairs</h5>
              </b>
            </p>

            <p> Zhexuan Zhu &nbsp; | &nbsp; Shenzhen University &nbsp; | &nbsp; Shenzhen, China </p>
            <p> Andres Iglesias &nbsp; | &nbsp; University of Cantabria &nbsp; | &nbsp; SANTANDER, Spain </p>



            <p>
              <span>&nbsp;</span>
            </p>
            <p>
              <b>
                <h5>Invited Session Co-chairs </h5>
              </b>
            </p>

            <p> Zhihui Zhan &nbsp; | &nbsp; South China University of Techology &nbsp; | &nbsp; Guangzhou, China </p>
            <p> Zhun Fan &nbsp; | &nbsp; Shantou University &nbsp; | &nbsp; Shangtou, China </p>
            <p> Maoguo Gong &nbsp; | &nbsp; Xidian University &nbsp; | &nbsp; Xi&apos;an, China </p>


            <p>
              <span>&nbsp; </span>
            </p>

            <p>
              <b>
                <h5>Special Session Co-chairs</h5>
              </b>
            </p>

            <p> Ben Niu &nbsp; | &nbsp; Shenzhen University &nbsp; | &nbsp; Shenzhen, China </p>
            <p> Yan Pei &nbsp; | &nbsp; University of Aizu &nbsp; | &nbsp; Fukushima, Japan </p>
            <p> Ming Jiang &nbsp; | &nbsp; Xiamen University &nbsp; | &nbsp; Xiamen, China </p>


            <p>
              <span>&nbsp; </span>
            </p>


            <p>
              <b>
                <h5>Publication Co-chairs</h5>
              </b>
            </p>

            <p> Swagatham Das &nbsp; | &nbsp; Indian Statistical Institute &nbsp; | &nbsp; Kolkata, India </p>
            <p> Radu-Emil Precup &nbsp; | &nbsp; Politehnica University of Timisoara &nbsp; | &nbsp; Timisoara, Romania </p>


            <p>
              <span>&nbsp; </span>
            </p>

            <p>
              <b>
                <h5>Tutorial Co-chairs</h5>
              </b>
            </p>


            <p> Jiahai Wang &nbsp; | &nbsp; Sun Yatsan University &nbsp; | &nbsp; Guangzhou, China </p>
            <p> Junqi Zhang &nbsp; | &nbsp; Tongji University &nbsp; | &nbsp; Shanghai, China </p>
            <p> Han Huang &nbsp; | &nbsp; South China University of Techology &nbsp; | &nbsp; Guangzhou, China </p>


            <p>
              <b>
                <h5>Publicity Co-chairs</h5>
              </b>
            </p>

            <p> Fernando Buarque &nbsp; | &nbsp; Universidade of Pernambuco &nbsp; | &nbsp; Recife, Brazil </p>
            <p> Eugene Semenkin &nbsp; | &nbsp; Siberian Aerospace University &nbsp; | &nbsp; Krasnoyarsk, Russia </p>
            <p> Jing Liu &nbsp; | &nbsp; Xidian University, Guangzhou Institute of Technology &nbsp; | &nbsp; Guangzhou, China </p>
            <p> Hongwei Mo &nbsp; | &nbsp; Harbin Engineering University &nbsp; | &nbsp; Harbin, China </p>
            <p> Liangjun Ke &nbsp; | &nbsp; Xi&apos;an Jiaotong University &nbsp; | &nbsp; Xi&apos;an, China </p>
            <p> Shenli Xie &nbsp; | &nbsp; South China University of Techology &nbsp; | &nbsp; Guangzhou, China </p>
            <p> Qiuzhen Lin &nbsp; | &nbsp; Shenzhen University &nbsp; | &nbsp; Shenzhen, China </p>
            <p> Mario F. Pavone &nbsp; | &nbsp; University of Catania &nbsp; | &nbsp; Catania, Italy </p>



            <span> &nbsp; </span>


            <p>
              <span>&nbsp; </span>
            </p>


            <p>
              <b>
                <h5>Finance and Registration Co-chairs</h5>
              </b>
            </p>

            <p> Andreas Janecek &nbsp; | &nbsp; University of Vienna &nbsp; | &nbsp; Vienna, Austria </p>
            <p> Suicheng Gu &nbsp; | &nbsp; Google Corporation &nbsp; | &nbsp; San Franocisco, USA </p>


            <p>
              <span>&nbsp; </span>
            </p>

            <p>
              <b>
                <h5>Conference Secretariat</h5>
              </b>
            </p>

            <p> YuLong Sha &nbsp; | &nbsp; Peking University &nbsp; | &nbsp; Beijing, China </p>
            <p> Yifan Liu &nbsp; | &nbsp; Peking University &nbsp; | &nbsp; Beijing, China </p>


            <p>
              <span>&nbsp; </span>
            </p>


            {/* <p>
              <b>
                <h5>Local Arrangement Co-chairs </h5>
              </b>
            </p>

            <p>Jiacheng Li | Kanagawa University | Yokohama, Japan</p>
            <p>Masato Noto | Kanagawa University | Yokohama, Japan</p>
            <p> Masanori Akiyoshi | Kanagawa University | Yokohama, Japan </p>
            <p> Jia Guo | Nagoya University | Nagoya, Japan</p>
            <p> Tutomu Ishida | Ryutsu Keizai University | Japan</p>
            <p> Bin Zhang | Kanagawa University | Yokohama, Japan</p> */}



            {/* <p>
              <b>
                <h5>Sponsors and Co-Sponsors</h5>
              </b>
            </p>

            <p>
              International Association of Swarm and Evolutionary Intelligences
              (IASEI)
            </p>

            <p>
              <span>Xi&apos;an Jiaotong University </span>
            </p>
            <p>
              <span>Shaanxi Normal University </span>
            </p>
            <p>
              <span>Xidian Univeresity </span>
            </p>
            <p>
              <span>Peking University </span>
            </p>

            <p>
              <span>Southern University of Science and Technology </span>
            </p>

            <p>
              <span>Beijing XingHui Hi-Tech Co. </span>
            </p>
            <p>
              <span>Nanjiing Kangbo Intelligent Health Academy </span>
            </p>

            <p></p>

            <span> &nbsp; </span>
            <p>
              <b>
                <h5>Technical Co-sponsors</h5>
              </b>
            </p>

            <p>
              <span>IEEE Computational Intelligence Society </span>
            </p>

            <p>
              <span>IEEE Beijing Chapter </span>
            </p>

            <p>
              <span>World Federation of Soft Computing </span>
            </p>

            <p>
              <span>International Society of Neural Net </span>
            </p>

            <p>
              <span>Springer</span>-Nature
            </p>

            <p>
              <span>De Gruyter Open </span>
            </p>

            <p></p> */}

            <br />
            <br />
            <br />

            <p>
              <h5 align="center">International Program Committee </h5>
            </p>
          </div>
          <table cellPadding={0} cellSpacing={0}>
            <colgroup>
              <col width={200} />
              <col width={200} />
              <col width={687} />
            </colgroup>
            <tbody>
              <tr height={18}>
                <td height={18} width={150}>
                  <div align="left">
                    <strong>First Name</strong>
                  </div>
                </td>
                <td width={180}>
                  <div align="left">
                    <strong>Last Name</strong>
                  </div>
                </td>
                <td width={687}>
                  <div align="left">
                    <strong>Affiliate</strong>
                  </div>
                </td>
              </tr>

              {TableData &&
                TableData.map((single, key) => {
                  return <Commitee data={single} key={key} />;
                })}

            </tbody>
          </table>

          <p></p>

          <p></p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Committees;
